"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var quadkey_1 = require("../../utils/quadkey");
var staticService = require('@mapbox/mapbox-sdk/services/static');
exports.StaticQuadkeyMap = function (_a) {
    var accessToken = _a.accessToken, quadkey = _a.quadkey, style = _a.style;
    var imgSrc = react_1.useMemo(function () {
        try {
            var _a = quadkey_1.origin(quadkey), lng = _a.lng, lat = _a.lat;
            var coordinates = quadkey_1.quadkeyCoordinates(quadkey);
            var url = staticService({ accessToken: accessToken })
                .getStaticImage({
                ownerId: 'mapbox',
                styleId: 'dark-v10',
                width: 300,
                height: 300,
                position: {
                    pitch: 60,
                    bearing: 180,
                    zoom: quadkey.length - 2,
                    coordinates: [lng, lat],
                },
                overlays: [
                    {
                        path: {
                            strokeOpacity: 0.7,
                            strokeColor: '#F89D42',
                            strokeWidth: 4,
                            coordinates: coordinates,
                        },
                    },
                ],
            })
                .url();
            return url;
        }
        catch (e) {
            console.warn('Static image', e.message);
            return '';
        }
    }, [quadkey]);
    return (react_1.default.createElement("div", { style: __assign(__assign({}, style), { backgroundImage: "url(\"" + imgSrc + "\")", backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }) }));
};
exports.StaticBoundsMap = function (_a) {
    var accessToken = _a.accessToken, coordinates = _a.coordinates, style = _a.style;
    var imgSrc = react_1.useMemo(function () {
        var geoJson = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: { 'fill-opacity': 0.7, fill: '#5D3A7B' },
                    geometry: {
                        type: 'Polygon',
                        coordinates: coordinates,
                    },
                },
            ],
        };
        return staticService({ accessToken: accessToken })
            .getStaticImage({
            ownerId: 'mapbox',
            styleId: 'dark-v10',
            width: 300,
            height: 300,
            position: 'auto',
            overlays: [{ geoJson: geoJson }],
        })
            .url() + "?access_token=" + accessToken;
    }, [coordinates]);
    return (react_1.default.createElement("div", { style: __assign(__assign({}, style), { backgroundImage: "url(\"" + imgSrc + "\")", backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }) }));
};
//# sourceMappingURL=index.js.map